import { render, staticRenderFns } from "./Palmares.vue?vue&type=template&id=04bb5b9f&scoped=true&"
import script from "./Palmares.vue?vue&type=script&lang=js&"
export * from "./Palmares.vue?vue&type=script&lang=js&"
import style0 from "./Palmares.vue?vue&type=style&index=0&id=04bb5b9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb5b9f",
  null
  
)

export default component.exports